import { formatCurrency } from '@fortress-technology-solutions/fortress-component-library/utils/index';

const toNumber = (value) => {
  if (value == null || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  if (trimmed === '') {
    return null;
  }

  const num = Number(trimmed);
  return Number.isFinite(num) ? num : null;
};

/**
 * Derives the prepaid balance when the API leaves `prepaidBalance` at 0 but
 * stores credits in sub-journal fields as negative amounts.
 */
export const getEffectivePrepaidBalance = ({
  prepaidBalance,
  residentPrepaid,
  subsidyPrepaid,
}) => {
  const prepaid = toNumber(prepaidBalance);
  if (prepaid != null && prepaid !== 0) {
    return prepaid;
  }

  const subjournalSum =
    (toNumber(residentPrepaid) ?? 0) + (toNumber(subsidyPrepaid) ?? 0);
  if (subjournalSum !== 0) {
    return subjournalSum;
  }

  return prepaid ?? 0;
};

export const normalizeDelinquencyRow = (row) => ({
  ...row,
  prepaidBalance: getEffectivePrepaidBalance(row),
});

export const normalizeDelinquencyRows = (rows = []) =>
  rows.map(normalizeDelinquencyRow);

export const buildGrandTotalForCSVExport = ({
  totals,
  filteredHeaders,
  footerRow,
}) => {
  return filteredHeaders.map(({ id }, index) => {
    let result = '';
    if (index === 0 && !totals[id]) {
      result = '"Totals"';
    }
    if (totals[id]) {
      const { value } = footerRow[id];
      result = `"${formatCurrency(value)}"`;
    }
    return result;
  });
};
